import {Button, Card, Stack, Typography} from "@mui/joy";
import React from "react";
import {useNavigate} from "react-router-dom";
import {motion} from "motion/react";
import {gradientPairs} from "../../../theme";
import GuestNavbar from "../../../components/Layout/GuestNavbar";
import {APP_URL} from "../../../constants";
import {productionMode} from "../../../utils/routes";
import {useTranslation} from "react-i18next";

type ExamPageLayoutProps = {
    title: string;
    subtitle: string;
    description: string;
    structure?: string;
};

const ExamPageLayout = ({title, subtitle, description, structure}: ExamPageLayoutProps) => {
    const navigate = useNavigate()
    const {t} = useTranslation()

    const handleStartPreparing = () => {
        if (productionMode)
            window.location.href = APP_URL
        else navigate("/register")
    }

    return (
        <Stack sx={{minHeight: "100vh", overflowX: "hidden"}}>
            <GuestNavbar/>

            <Stack
                paddingX={{xs: 2, sm: 4, lg: 6}}
                paddingY={{xs: 4, md: 6}}
                gap={4}
                alignItems="center">
                <motion.div
                    initial={{opacity: 0, y: 16}}
                    animate={{opacity: 1, y: 0}}
                    transition={{duration: 0.4}}
                    style={{textAlign: "center", maxWidth: 720}}>
                    <Typography
                        level="h1"
                        sx={{fontSize: {xs: "1.75rem", md: "2.25rem"}, marginBottom: 0.5}}>
                        {title}
                    </Typography>
                    <Typography level="body-lg" textColor="neutral.600" sx={{marginBottom: 2}}>
                        {subtitle}
                    </Typography>
                    <Typography level="body-md" textColor="neutral.600">
                        {description}
                    </Typography>
                </motion.div>

                {structure && (
                    <Card
                        variant="outlined"
                        sx={{
                            maxWidth: 640,
                            width: "100%",
                            padding: 3,
                            borderRadius: 2,
                        }}
                        data-no-glow
                        data-no-animation>
                        <Typography level="title-md" sx={{marginBottom: 1}}>
                            {t("examStructureLabel")}
                        </Typography>
                        <Typography level="body-sm" textColor="neutral.600">
                            {structure}
                        </Typography>
                    </Card>
                )}

                <Stack direction={{xs: "column", sm: "row"}} gap={2}>
                    <Button
                        size="lg"
                        onClick={handleStartPreparing}
                        sx={{
                            background: `linear-gradient(to right, ${gradientPairs[0][0]}, ${gradientPairs[0][1]})`,
                        }}>
                        {t("primaryCallToActionLabel")}
                    </Button>
                    <Button size="lg" variant="outlined" onClick={() => navigate("/pricing")}>
                        {t("primaryCallToActionLabel")}
                    </Button>
                </Stack>
            </Stack>
        </Stack>)
}

export default ExamPageLayout;
